var _a;
import { TicketPriority } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[TicketPriority.Normal] = 'Normal',
    _a[TicketPriority.High] = 'High',
    _a[TicketPriority.Critical] = 'Critical',
    _a);
export var TicketPriorityEnum = {
    name: 'TicketPriority',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
